export const VEHICLE_PROJECTS_TRANSLATION_NAMESPACE =
	'features/vehicleprojects';
